import { RiskFactorType } from '../../../utils/type';
import { ApiMessage, ApiResponseHandler } from '../../ApiResponseHandler';
import ThomApiClient from '../../ThomApiClient';

export const getRiskFactorData = async (
  evaulationId: string,
  clientId: string | null,
  evaluationType: string,
): Promise<RiskFactorType> => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().get(
      `riskFactor?evaluationId=${evaulationId}&clientId=${clientId}&evaluationType=${evaluationType}`,
    ),
  );
};

export const addOrUpdateRiskFactor = async (
  params: RiskFactorType,
  clientId: string | null,
): Promise<ApiMessage> => {
  const url = params.id
    ? `riskFactor/${params.id}?evaluationId=${params.evaluationId}&clientId=${clientId}&evaluationType=${params.evaluationType}`
    : `riskFactor?evaluationId=${params.evaluationId}&clientId=${clientId}&evaluationType=${params.evaluationType}`;

  if (params.id) {
    // Update existing record
    return ApiResponseHandler(
      await ThomApiClient.getInstance().put<RiskFactorType, ApiMessage>(
        url,
        params,
      ),
    );
  } else {
    // Create new record
    return ApiResponseHandler(
      await ThomApiClient.getInstance().post<RiskFactorType, ApiMessage>(
        url,
        params,
      ),
    );
  }
};
